<template>
        
    <div class="card">
        <div class="card-body">

            <h4 
                class="card-title"
                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''">
                {{ label }}
            </h4>
            <div class="col-md-12 text-center" style="padding:0">
                <!-- <span 
                    v-if="bondTypeLoading"
                    class="spinner-grow spinner-grow-sm mr-1" 
                    role="status" 
                    aria-hidden="true">
                </span> -->
                <select 
                    id="select"
                    class="form-control" 
                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                    v-model="row.select"
                    v-on:change="onSelectChange">
                    <option 
                        v-for="(row, idx) in rows" 
                        :key="idx"
                        :value="row['id']">
                        {{ row['value'] }}
                    </option>
                </select>
            </div>
        </div>
    </div>
        
</template>

<script>
// import iziToast from 'izitoast';

export default {
    namme: 'CardPeriod',
    props: [
        'label',
        'select'
    ],
    data(){
        return {
            auth: {
                access_token: ''
            },
            row: {
                select: this.$props.select
            },
            rows: [
                    {'id' : 1, 'value': '1 '+this.$t('app.day')},
                    {'id' : 2, 'value': '2 '+this.$t('app.day')},
                    {'id' : 3, 'value': '3 '+this.$t('app.day')},
                    {'id' : 4, 'value': '4 '+this.$t('app.day')},
                    {'id' : 5, 'value': '5 '+this.$t('app.day')},
                    {'id' : 6, 'value': '6 '+this.$t('app.day')},
                    {'id' : 7, 'value': '7 '+this.$t('app.day')},
                    {'id' : 15, 'value': '15 '+this.$t('app.day')},
                    {'id' : 30, 'value': '30 '+this.$t('app.day')},
                    {'id' : 60, 'value': '60 '+this.$t('app.day')},
                    {'id' : 90, 'value': '90 '+this.$t('app.day')},
                ],
            loading: true,
        }
    },
    mounted() {},
    created() {
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }

        //this.fetchData();
    },
    methods: {
        onSelectChange(){
            const data = {
                select: this.row.select
            }
            this.$emit('selectChange', data);
        },

        // fetchData() {
        //     this.loading = true;
        //     this.axios.defaults.headers.common = {
        //         'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
        //         'Authorization': `Bearer ` + this.auth.access_token,
        //     };
        //     const options = {
        //         url: window.baseURL+'/financialbondtypes',
        //         method: 'GET',
        //         data: {},
        //         params: {
        //             status: 'active',
        //             paginate: 1000
        //         }
        //     }
        //     this.axios(options)
        //     .then(res => {
        //         this.bondTypeLoading = false;
        //         this.bondTypes = res.data.data.rows;
        //     })
        //     .catch(err => {
        //         this.bondTypeLoading = false;
        //         iziToast.warning({
        //             icon: 'bx bx-angry',
        //             title: '',
        //             message: (err.response) ? err.response.data.message : ''+err
        //         });
        //     })
        // },
    }
}
</script>
